import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import UserDataService from "../../services/User";
import { SelectNotificationModal } from "./SelectNotificationModal";
export const AdvanceNotificationModal = ({
  isOpen,
  onClose,
  category,
}: any) => {
  const { onOpen } = useDisclosure();
  const [age, setAge] = useState("");
  const [gender, setGender] = useState<any>("");
  const [modal, setModal] = useState("");
  const [target, setTarget] = useState<any>("");
  const [ids, setIds] = useState<any>([]);
  const getTargetName = () => {
    let targetName = age;
    if (gender) {
      if (!age) {
        targetName += `${gender}`;
      } else {
        targetName += `/ ${gender}`;
      }
    }
    setTarget(targetName);
  };
  const closeModal = () => {
    clearState();
    onClose();
  };
  const clearState = () => {
    setAge("");
    setGender("");
    // onClose();
  };
  function generateAgeRanges(
    minAge: number,
    maxAge: number,
    diff: number
  ): any[] {
    const ageRanges = [];

    ageRanges.push(`<${minAge}`);

    for (let i = minAge; i <= maxAge; i += diff) {
      const endAge = i + diff - 1;
      if (endAge <= maxAge) {
        ageRanges.push(`${i}-${endAge}`);
      } else {
        ageRanges.push(`${i}-${maxAge}`);
      }
    }

    ageRanges.push(`>${maxAge}`);

    return ageRanges;
  }

  const handleSubmit = () => {
    if (age || gender) {
      const testids = [
        "8merwrSzZjRS9fEZWhmVjLY6fuk2", // singhayush28321@gmail.com
        "mR4bL1kCOOQ4qKbK5rlNNuSXXmd2", // abhishek@manoshala.com
        "u1AJIUq2hbYtGvIu04AgSbPGRiD2", // abhisheksw4@gmail.com
        // "wdUXzFuNwVOwPOEPuMypvakfrxE2", // kratika@manoshala.com
        "LBtD4WltjQd7Z6G8tENOJDwMiK02", // kratikaagarwal1@gmail.com
        "gOiHHnBePCXIKIV8IBtNUClNN8H3", // nish1997ns@gmail.com
        "3QFuBpAtj9XNespGO80hEJRxB9g2", // amitkumarkvpgi@gmail.com
      ];

      UserDataService.getUserIdsByAdvanceFilter(age, gender)
        .then((res: any) => {
          // console.log(res.data);
          setIds([...res.data, ...testids]);
          setModal("NotificationModal");
          getTargetName();
          onOpen();
        })
        .catch((error: any) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    //   fetchUsers();
  }, []);
  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Filter users by age and gender</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel htmlFor="gender-select">Select Gender</FormLabel>
            <Select
              name=""
              id="gender-select"
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </Select>
          </FormControl>
          <FormControl mt={"25px"}>
            <FormLabel htmlFor="age-select">Select age range</FormLabel>
            <Select
              name=""
              id="age-select"
              onChange={(e) => setAge(e.target.value)}
            >
              <option value="">Select age range</option>
              {generateAgeRanges(18, 45, 5).map((el) => (
                <option value={el}>{el}</option>
              ))}
            </Select>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSubmit}
          >
            Next
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={closeModal}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
      {modal === "NotificationModal" && (
        <SelectNotificationModal
          isOpen={isOpen}
          onClose={closeModal}
          category={category}
          ids={ids}
          target={target}
        />
      )}
    </Modal>
  );
};
